// extracted by mini-css-extract-plugin
export default {"wrap":"Action_wrap__HoQMX","popover":"Action_popover__UfalU","added":"Action_added__Pn4rb","disabled":"Action_disabled__kqScP"};